<template>
  <div class="credit-card-method">
    <stripe-card
        :loading="loading"
        @token="addPaymentMethod"
        @error="showPaymentMethodError"
    ></stripe-card>
  </div>
</template>

<script>
import BaseModal from '../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    addPaymentMethod (token) {
      this.loading = true
      this.$store.dispatch('user/addPaymentMethod', token)
          .then(response => {
            this.$emit('confirm', response.data)
          })
          .then(() => {
            this.loading = false
          })
    },
    showPaymentMethodError (error) {
      this.$toasted.show(error.message, {
        type: 'error'
      })
    }
  }
}
</script>
